export default __webpack_public_path__ + "static/media/doller-round.b4a061fe.svg";